import React from 'react';
import T from 'prop-types';

import { TechnicalError } from 'srcAlias/client/segments/decision/pages/TechnicalError';
import { callErrorLogApi } from './callErrorLogApi';
import './style.css';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: '',
      errorInfo: '',
      hasError: false,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    callErrorLogApi({
      errorMessage: `${error}`,
      errorInfo,
      journeyStageCause: 'app',
    });
    this.setState({ errorInfo });
  }

  render() {
    const { title, children, appConfig, showStackTrace = true } = this.props;
    const { error } = this.state;

    if (error) {
      return (
        <TechnicalError
          showStackTrace={showStackTrace}
          title={title}
          error={error}
          appConfig={appConfig}
          segmentName={'decision'}
          pageName={'technicalError'}
        />
      );
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  title: T.string,
  children: T.node,
  showStackTrace: T.bool,
  setError: T.func,
  appConfig: T.object,
};

export default ErrorBoundary;
